import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3301cec8 = () => interopDefault(import('../pages/accessibilite.vue' /* webpackChunkName: "pages/accessibilite" */))
const _d3f7cf06 = () => interopDefault(import('../pages/bureau-etude-urbanisme.vue' /* webpackChunkName: "pages/bureau-etude-urbanisme" */))
const _d74ac2d8 = () => interopDefault(import('../pages/collectivites-territoriales.vue' /* webpackChunkName: "pages/collectivites-territoriales" */))
const _7a50ce20 = () => interopDefault(import('../pages/confidentialite.vue' /* webpackChunkName: "pages/confidentialite" */))
const _499a5d89 = () => interopDefault(import('../pages/ddt-ddtm-dreal.vue' /* webpackChunkName: "pages/ddt-ddtm-dreal" */))
const _5e6824ec = () => interopDefault(import('../pages/guide.vue' /* webpackChunkName: "pages/guide" */))
const _f63d168c = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _08bc2c6b = () => interopDefault(import('../pages/loi-climat-et-resilience.vue' /* webpackChunkName: "pages/loi-climat-et-resilience" */))
const _582fa485 = () => interopDefault(import('../pages/mentions-legales.vue' /* webpackChunkName: "pages/mentions-legales" */))
const _093dbe70 = () => interopDefault(import('../pages/stats/index.vue' /* webpackChunkName: "pages/stats/index" */))
const _496c825b = () => interopDefault(import('../pages/validation.vue' /* webpackChunkName: "pages/validation" */))
const _6c4ca42e = () => interopDefault(import('../pages/dev/api.vue' /* webpackChunkName: "pages/dev/api" */))
const _449c0e40 = () => interopDefault(import('../pages/login/collectivites/explain.vue' /* webpackChunkName: "pages/login/collectivites/explain" */))
const _4c7be62e = () => interopDefault(import('../pages/login/collectivites/signin.vue' /* webpackChunkName: "pages/login/collectivites/signin" */))
const _234f3942 = () => interopDefault(import('../pages/login/collectivites/signup.vue' /* webpackChunkName: "pages/login/collectivites/signup" */))
const _647b0cc4 = () => interopDefault(import('../pages/login/ddt/explain.vue' /* webpackChunkName: "pages/login/ddt/explain" */))
const _5af1a436 = () => interopDefault(import('../pages/login/ddt/signin.vue' /* webpackChunkName: "pages/login/ddt/signin" */))
const _31c4f74a = () => interopDefault(import('../pages/login/ddt/signup.vue' /* webpackChunkName: "pages/login/ddt/signup" */))
const _1c6e0060 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _23a0b957 = () => interopDefault(import('../pages/collectivites/_code_collectivite.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite" */))
const _5a7ca29a = () => interopDefault(import('../pages/collectivites/_code_collectivite/index.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/index" */))
const _c87db1a0 = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees" */))
const _917e6e4e = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees/data.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees/data" */))
const _130229a8 = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees/geoide.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees/geoide" */))
const _0ad39aec = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees/georisques.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees/georisques" */))
const _424db2cd = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees/gpu.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees/gpu" */))
const _683b7a92 = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees/inpn.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees/inpn" */))
const _5c0411af = () => interopDefault(import('../pages/collectivites/_code_collectivite/informations.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/informations" */))
const _728562ec = () => interopDefault(import('../pages/collectivites/_collectiviteId.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId" */))
const _4212ab02 = () => interopDefault(import('../pages/collectivites/_collectiviteId/glossaire.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/glossaire" */))
const _22576d6f = () => interopDefault(import('../pages/collectivites/_collectiviteId/pac.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/pac" */))
const _59e254b9 = () => interopDefault(import('../pages/collectivites/_collectiviteId/prescriptions/index.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/prescriptions/index" */))
const _b9712a6a = () => interopDefault(import('../pages/collectivites/_collectiviteId/ressources.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/ressources" */))
const _4af72670 = () => interopDefault(import('../pages/collectivites/_collectiviteId/prescriptions/add.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/prescriptions/add" */))
const _cbe2217e = () => interopDefault(import('../pages/collectivites/_collectiviteId/prescriptions/signup.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/prescriptions/signup" */))
const _0f501745 = () => interopDefault(import('../pages/collectivites/_collectiviteId/procedures/add.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/procedures/add" */))
const _e836f4a6 = () => interopDefault(import('../pages/ddt/_departement.vue' /* webpackChunkName: "pages/ddt/_departement" */))
const _fde15320 = () => interopDefault(import('../pages/ddt/_departement/index.vue' /* webpackChunkName: "pages/ddt/_departement/index" */))
const _02789011 = () => interopDefault(import('../pages/ddt/_departement/collectivites/index.vue' /* webpackChunkName: "pages/ddt/_departement/collectivites/index" */))
const _944b22f2 = () => interopDefault(import('../pages/ddt/_departement/enquete.vue' /* webpackChunkName: "pages/ddt/_departement/enquete" */))
const _5df547b0 = () => interopDefault(import('../pages/ddt/_departement/pac.vue' /* webpackChunkName: "pages/ddt/_departement/pac" */))
const _0cf1eb55 = () => interopDefault(import('../pages/ddt/_departement/procedures/index.vue' /* webpackChunkName: "pages/ddt/_departement/procedures/index" */))
const _9a979138 = () => interopDefault(import('../pages/ddt/_departement/procedures/choix-collectivite.vue' /* webpackChunkName: "pages/ddt/_departement/procedures/choix-collectivite" */))
const _02f63bcd = () => interopDefault(import('../pages/ddt/_departement/collectivites/_collectiviteId/commune.vue' /* webpackChunkName: "pages/ddt/_departement/collectivites/_collectiviteId/commune" */))
const _3412b498 = () => interopDefault(import('../pages/ddt/_departement/collectivites/_collectiviteId/epci.vue' /* webpackChunkName: "pages/ddt/_departement/collectivites/_collectiviteId/epci" */))
const _16108a92 = () => interopDefault(import('../pages/ddt/_departement/collectivites/_collectiviteId/procedure/add.vue' /* webpackChunkName: "pages/ddt/_departement/collectivites/_collectiviteId/procedure/add" */))
const _c460cbd8 = () => interopDefault(import('../pages/frise/_procedureId/index.vue' /* webpackChunkName: "pages/frise/_procedureId/index" */))
const _a4ce8ece = () => interopDefault(import('../pages/print/_projectId.vue' /* webpackChunkName: "pages/print/_projectId" */))
const _c4b3ee54 = () => interopDefault(import('../pages/trames/_githubRef.vue' /* webpackChunkName: "pages/trames/_githubRef" */))
const _6597a566 = () => interopDefault(import('../pages/documents/_githubRef/pac.vue' /* webpackChunkName: "pages/documents/_githubRef/pac" */))
const _17ad663a = () => interopDefault(import('../pages/frise/_procedureId/add.vue' /* webpackChunkName: "pages/frise/_procedureId/add" */))
const _39a4b2b7 = () => interopDefault(import('../pages/frise/_procedureId/invite.vue' /* webpackChunkName: "pages/frise/_procedureId/invite" */))
const _3ed04712 = () => interopDefault(import('../pages/frise/_procedureId/update.vue' /* webpackChunkName: "pages/frise/_procedureId/update" */))
const _60620bc4 = () => interopDefault(import('../pages/frise/_procedureId/_eventId.vue' /* webpackChunkName: "pages/frise/_procedureId/_eventId" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/accessibilite",
    component: _3301cec8,
    name: "accessibilite"
  }, {
    path: "/bureau-etude-urbanisme",
    component: _d3f7cf06,
    name: "bureau-etude-urbanisme"
  }, {
    path: "/collectivites-territoriales",
    component: _d74ac2d8,
    name: "collectivites-territoriales"
  }, {
    path: "/confidentialite",
    component: _7a50ce20,
    name: "confidentialite"
  }, {
    path: "/ddt-ddtm-dreal",
    component: _499a5d89,
    name: "ddt-ddtm-dreal"
  }, {
    path: "/guide",
    component: _5e6824ec,
    name: "guide"
  }, {
    path: "/login",
    component: _f63d168c,
    name: "login"
  }, {
    path: "/loi-climat-et-resilience",
    component: _08bc2c6b,
    name: "loi-climat-et-resilience"
  }, {
    path: "/mentions-legales",
    component: _582fa485,
    name: "mentions-legales"
  }, {
    path: "/stats",
    component: _093dbe70,
    name: "stats"
  }, {
    path: "/validation",
    component: _496c825b,
    name: "validation"
  }, {
    path: "/dev/api",
    component: _6c4ca42e,
    name: "dev-api"
  }, {
    path: "/login/collectivites/explain",
    component: _449c0e40,
    name: "login-collectivites-explain"
  }, {
    path: "/login/collectivites/signin",
    component: _4c7be62e,
    name: "login-collectivites-signin"
  }, {
    path: "/login/collectivites/signup",
    component: _234f3942,
    name: "login-collectivites-signup"
  }, {
    path: "/login/ddt/explain",
    component: _647b0cc4,
    name: "login-ddt-explain"
  }, {
    path: "/login/ddt/signin",
    component: _5af1a436,
    name: "login-ddt-signin"
  }, {
    path: "/login/ddt/signup",
    component: _31c4f74a,
    name: "login-ddt-signup"
  }, {
    path: "/",
    component: _1c6e0060,
    name: "index"
  }, {
    path: "/collectivites/:code_collectivite?",
    component: _23a0b957,
    children: [{
      path: "",
      component: _5a7ca29a,
      name: "collectivites-code_collectivite"
    }, {
      path: "donnees",
      component: _c87db1a0,
      name: "collectivites-code_collectivite-donnees",
      children: [{
        path: "data",
        component: _917e6e4e,
        name: "collectivites-code_collectivite-donnees-data"
      }, {
        path: "geoide",
        component: _130229a8,
        name: "collectivites-code_collectivite-donnees-geoide"
      }, {
        path: "georisques",
        component: _0ad39aec,
        name: "collectivites-code_collectivite-donnees-georisques"
      }, {
        path: "gpu",
        component: _424db2cd,
        name: "collectivites-code_collectivite-donnees-gpu"
      }, {
        path: "inpn",
        component: _683b7a92,
        name: "collectivites-code_collectivite-donnees-inpn"
      }]
    }, {
      path: "informations",
      component: _5c0411af,
      name: "collectivites-code_collectivite-informations"
    }]
  }, {
    path: "/collectivites/:collectiviteId?",
    component: _728562ec,
    name: "collectivites-collectiviteId",
    children: [{
      path: "glossaire",
      component: _4212ab02,
      name: "collectivites-collectiviteId-glossaire"
    }, {
      path: "pac",
      component: _22576d6f,
      name: "collectivites-collectiviteId-pac"
    }, {
      path: "prescriptions",
      component: _59e254b9,
      name: "collectivites-collectiviteId-prescriptions"
    }, {
      path: "ressources",
      component: _b9712a6a,
      name: "collectivites-collectiviteId-ressources"
    }, {
      path: "prescriptions/add",
      component: _4af72670,
      name: "collectivites-collectiviteId-prescriptions-add"
    }, {
      path: "prescriptions/signup",
      component: _cbe2217e,
      name: "collectivites-collectiviteId-prescriptions-signup"
    }, {
      path: "procedures/add",
      component: _0f501745,
      name: "collectivites-collectiviteId-procedures-add"
    }]
  }, {
    path: "/ddt/:departement?",
    component: _e836f4a6,
    children: [{
      path: "",
      component: _fde15320,
      name: "ddt-departement"
    }, {
      path: "collectivites",
      component: _02789011,
      name: "ddt-departement-collectivites"
    }, {
      path: "enquete",
      component: _944b22f2,
      name: "ddt-departement-enquete"
    }, {
      path: "pac",
      component: _5df547b0,
      name: "ddt-departement-pac"
    }, {
      path: "procedures",
      component: _0cf1eb55,
      name: "ddt-departement-procedures"
    }, {
      path: "procedures/choix-collectivite",
      component: _9a979138,
      name: "ddt-departement-procedures-choix-collectivite"
    }, {
      path: "collectivites/:collectiviteId/commune",
      component: _02f63bcd,
      name: "ddt-departement-collectivites-collectiviteId-commune"
    }, {
      path: "collectivites/:collectiviteId/epci",
      component: _3412b498,
      name: "ddt-departement-collectivites-collectiviteId-epci"
    }, {
      path: "collectivites/:collectiviteId/procedure/add",
      component: _16108a92,
      name: "ddt-departement-collectivites-collectiviteId-procedure-add"
    }]
  }, {
    path: "/frise/:procedureId",
    component: _c460cbd8,
    name: "frise-procedureId"
  }, {
    path: "/print/:projectId?",
    component: _a4ce8ece,
    name: "print-projectId"
  }, {
    path: "/trames/:githubRef?",
    component: _c4b3ee54,
    name: "trames-githubRef"
  }, {
    path: "/documents/:githubRef?/pac",
    component: _6597a566,
    name: "documents-githubRef-pac"
  }, {
    path: "/frise/:procedureId?/add",
    component: _17ad663a,
    name: "frise-procedureId-add"
  }, {
    path: "/frise/:procedureId?/invite",
    component: _39a4b2b7,
    name: "frise-procedureId-invite"
  }, {
    path: "/frise/:procedureId?/update",
    component: _3ed04712,
    name: "frise-procedureId-update"
  }, {
    path: "/frise/:procedureId?/:eventId",
    component: _60620bc4,
    name: "frise-procedureId-eventId"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
